import { render, staticRenderFns } from "./ValintaTable.vue?vue&type=template&id=57f2ad02&scoped=true"
import script from "./ValintaTable.vue?vue&type=script&lang=js"
export * from "./ValintaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2ad02",
  null
  
)

export default component.exports